import { IArticle } from '../shared/types/articles';

import { IErrors, instance } from './index';

export interface IGetArticles extends IErrors {
  articles: IArticle[];
}

export interface IGetArticlesItem extends IErrors {
  article: IArticle;
}

export const PublicationApi = () => ({
  async getLimited(limit: number, offset?: number) {
    const { data } = await instance.get<IGetArticles>(
      `/api/articles${limit ? `?limit=${limit}` : ''}${
        offset ? `&offset=${offset}` : '&offset=0'
      }`
    );
    return data;
  },
  async getOne(slug: string | undefined) {
    const { data } = await instance.get<IGetArticlesItem>(
      `/api/articles/${slug}`
    );
    return data;
  },
});
